/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Exists from './Exists/index'
import No from './No/index'
import NoLocation from './NoLocation/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/LocationAction/Location"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalCurrentLocationValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: globalCurrentLocationValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Exists'}>
<Exists
  viewPath={`${viewPath}/Exists`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoLocation'}>
<NoLocation
  viewPath={`${viewPath}/NoLocation`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}